import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import RequestJSON from './RequestJSON';
function Webhook() {
const [ShowHideAccordionOne, SetShowHideAccordionOne] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const onClickAccordianShowHideOne = () => {
SetShowHideAccordionOne(!ShowHideAccordionOne)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>Webhook</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2>Webhook response</h2>
            <p>
               Webhooks are user-defined HTTP callbacks, operating at the server to server (S2S) communication levels. The S2S callback is more recommendable feature while integrating with Safexpay. Basically, Safexpay sends the final transaction response to the merchant via browser redirection on real time transactions. However, due to network issues or some other technical glitch, this browser redirection may not be successful, and the transaction may get dropped (between Safexpay and Merchant). In such events, the merchant will not be able to complete the processing of the order at their end. For such cases, this callback feature can be used effectively.
            </p>
            <p>
               <b>Step 1:</b> The merchants should create their server URL (Ex: www.abc.com/success/response) and share it with Safexpay, along with its server IP address. It is the URL at which the transaction response from Safexpay will hit.
            </p>
            <p>
               <b>Step 2:</b> Safexpay will configure the merchant’s Server URL at its back-end, mapping it against the Production MID which has been shared.
            </p>
            <p>
               <b>Step 3:</b> To establish the connection, Safexpay will Whitelist the webhook URL provided by merchant in its systems. And, the merchant also needs to whitelist the following IP address as per the dependency upon the firewall side to receive a response from the Safexpay servers.
            </p>
            <p>
               <b>Step 4:</b> Safexpay will send S2S response to the merchant’s server URL.
            </p>
            <p>
               Merchant’s server URL should be capable of handling the following the Supported content types:
            </p>
            <ul>
               <li>FormData</li>
               <li>application/x-www-form-urlencode</li>
               <li>application/json</li>
            </ul>
            <p>
               So, while creating the server URL, the merchant needs to ensure that it can accept the data in the above content formats.
            </p>
            <p>
               <b>Step 5:</b> Merchant must share the below details for configuring the Webhook at Safexpay Server to the Integration’s email id.
            </p>
            <u>
               <h5>Prerequisites for implementing WebHook</h5>
            </u>
            <ul>
               <li>Merchant ID</li>
               <li>Webhook configured URL where merchant wants to receive the response</li>
               <li>Server IP address</li>
               <li>Email Id</li>
               <li>SSL Certificate</li>
               <li>List of Events as per requirement.</li>
            </ul>
            <p>
               <b>Step 6:</b> Webhook can be triggered for any of the following events as per the requirement.
            </p>
            <table class="table table-bordered">
               <tbody>
                  <tr>
                     <th>Event No</th>
                     <th>Event Name</th>
                     <th>Event Description</th>
                  </tr>
                  <tr>
                     <td>1</td>
                     <td>RefundRI</td>
                     <td>Refund request Initiated</td>
                  </tr>
                  <tr>
                     <td>2</td>
                     <td>SaleRP</td>
                     <td>Sale Request Processed</td>
                  </tr>
                  <tr>
                     <td>3</td>
                     <td>SaleRF</td>
                     <td>Sale Request Failed</td>
                  </tr>
                  <tr>
                     <td>4</td>
                     <td>RefundRP</td>
                     <td>Refund Request Processed</td>
                  </tr>
                  <tr>
                     <td>5</td>
                     <td>ReconciledWRGoB</td>
                     <td>Reconciled With Payment Gateway / Bank</td>
                  </tr>
                  <tr>
                     <td>6</td>
                     <td>CancelledBC</td>
                     <td>Cancelled By Customer</td>
                  </tr>
                  <tr>
                     <td>6</td>
                     <td>Aborted</td>
                     <td>Aborted</td>
                  </tr>
               </tbody>
            </table>
            <h6><u>AUTHORIZATIONS:</u></h6>
            <h6 className="mt-10">REQUEST BODY SCHEMA:  application-json</h6>
            <hr class="hr-col">
            </hr>
            <p>Array () [</p>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="publishId"><span class="sc-iemWCZ fhDkLh"></span><span>publishId</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>publishId Request Received</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="acc_creation_datetime"><span class="sc-iemWCZ fhDkLh"></span><span>acc_creation_datetime</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">String</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Auth Request Received</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr className='expanded last undefined'>
                     <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideOne}>
                        <span className='sc-iemWCZ fhDkLh'></span>
                        <span>
                           Data {ShowHideAccordionOne ? 
                           <FaAngleDown/>
                           : 
                           <FaAngleUp/>
                           }
                        </span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  {ShowHideAccordionOne &&
                  <tr className='expanded last undefined'>
                     <td colspan="2" className=" sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                           <table class="sc-hHEiqL iZJLLY">
                              <tbody>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AuthRR"><span class="sc-iemWCZ fhDkLh"></span><span>AuthRR</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Auth Request Received</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AuthVRR"><span class="sc-iemWCZ fhDkLh"></span><span>AuthVRR</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Auth Void Request Received</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="CaptureRR"><span class="sc-iemWCZ fhDkLh"></span><span>CaptureRR</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Capture Request Received</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="SaleRR"><span class="sc-iemWCZ fhDkLh"></span><span>SaleRR</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Sale Request Received</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="RefundRI"><span class="sc-iemWCZ fhDkLh"></span><span>RefundRI</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Refund request Initiated</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="RequestSTPGoB"><span class="sc-iemWCZ fhDkLh"></span><span>RequestSTPGoB</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Request Sent To Payment Gateway / Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ResponseRFPGoB"><span class="sc-iemWCZ fhDkLh"></span><span>ResponseRFPGoB</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Response Received From Payment Gateway / Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="VerificationRSTPGo"><span class="sc-iemWCZ fhDkLh"></span><span>VerificationRSTPGo</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Verification Request Sent To Payment Gateway/ Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="VerificationRRFPGoB"><span class="sc-iemWCZ fhDkLh"></span><span>VerificationRRFPGoB</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Verification Response Received From Payment Gateway / Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="NoRRFPGoB"><span class="sc-iemWCZ fhDkLh"></span><span>NoRRFPGoB</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>No Response Received from Payment Gateway/ Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AuthRP"><span class="sc-iemWCZ fhDkLh"></span><span>AuthRP</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Auth Request Processed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AuthRF"><span class="sc-iemWCZ fhDkLh"></span><span>AuthRF</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Auth Request Failed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AuthVRP"><span class="sc-iemWCZ fhDkLh"></span><span>AuthVRP</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Auth Void Request Processed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AuthVRF"><span class="sc-iemWCZ fhDkLh"></span><span>AuthVRF</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Auth Void Request Failed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="CaptureRP"><span class="sc-iemWCZ fhDkLh"></span><span>CaptureRP</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Capture Request Processed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="CaptureRF"><span class="sc-iemWCZ fhDkLh"></span><span>CaptureRF</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Capture Request Failed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="SaleRP"><span class="sc-iemWCZ fhDkLh"></span><span>SaleRP</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Sale Request Processed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="RefundRP"><span class="sc-iemWCZ fhDkLh"></span><span>RefundRP</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Sale Request Failed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="RefundRF"><span class="sc-iemWCZ fhDkLh"></span><span>RefundRF</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Sale Request Failed</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ReconciledWRGoB"><span class="sc-iemWCZ fhDkLh"></span><span>ReconciledWRGoB</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Reconciled With Payment Gateway / Bank</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="SettlementD"><span class="sc-iemWCZ fhDkLh"></span><span>SettlementD</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Settlement Done</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ReconciledM"><span class="sc-iemWCZ fhDkLh"></span><span>ReconciledM</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Reconciled Mismatch</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="MerchantPD"><span class="sc-iemWCZ fhDkLh"></span><span>MerchantPD</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Merchant Payout Done</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="CancelledBC"><span class="sc-iemWCZ fhDkLh"></span><span>CancelledBC</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Cancelled By Customer</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Aborted"><span class="sc-iemWCZ fhDkLh"></span><span>Aborted</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Aborted</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr>
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="HostTO"><span class="sc-iemWCZ fhDkLh"></span><span>HostTO</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Host Time Out</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                                 <tr class="last undefined">
                                    <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="AmountM"><span class="sc-iemWCZ fhDkLh"></span><span>AmountM</span></td>
                                    <td class="sc-bkbkJK gmOLLi">
                                       <div>
                                          <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">array</span></div>
                                          <div>
                                             <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                <p>Amount Mismatch</p>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </td>
                  </tr>
                  }
               </tbody>
            </table>
            <p>]</p>
            <h5 className="mt-30">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header">
                     <h5 class="mb-0" style={{ backgroundColor: "rgb(239 246 240)"}}>
                     <span style={{ color: "rgb(29, 129, 39)"}}>200</span> </h5>
                  </div>
               </div>
               <div class="card">
                  <div class="card-header">
                     <h5 class="mb-0"> <span>400 Bad Request</span> </h5>
                  </div>
               </div>
               <div class="card">
                  <div class="card-header">
                     <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
                  </div>
               </div>
               <div class="card">
                  <div class="card-header">
                     <h5 class="mb-0"> <span>404 Not found</span> </h5>
                  </div>
               </div>
            </div>
         </div>
         <div class="col-md-4 extreme-rt-div">
            <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                        <button> POST </button> /webhook/url {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <br />
                  <div class="card-body">
                     <p class="mb-0">Production server (uses live data)</p>
                     <div class="api-div-bor">
                        <span>https://www.avantgardepayments.com</span><span
                           class="col-org">/agcore/webhook/url</span>
                     </div>
                     <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                     <div class="api-div-bor">
                        <span>https://pguat.safexpay.com</span><span
                           class="col-org">/agcore/webhook/url</span>
                     </div>
                  </div>
               </div>
               }
            </div>
         </div>
         <RequestJSON/>
      </div>
   </div>
</div>
</div>
)
}
export default Webhook